import "core-js/modules/es.object.to-string.js";
import { MessageBox } from 'element-ui';
import { oneDayLong } from 'util/util';
import Cookies from 'js-cookie';

/**
 * @param {string} time
 * @returns 当剩余 day 天过期，弹框
 */
export default (function (_ref, $t) {
  var expire_time = _ref.expire_time,
    audit_status = _ref.audit_status;
  // 剩余 多少 天
  var day = +Math.ceil((new Date(expire_time).getTime() - Date.now()) / oneDayLong) + 1;
  // 未认证 且 小于等于7天 并且 在 7天内没有弹过框
  if (audit_status === '2' && day <= 7 && !Cookies.get('isExpireDialog')) {
    MessageBox({
      title: $t('prompt'),
      message: $t('expire_dialog.1', {
        day: day
      }),
      showClose: false,
      closeOnClickModal: false,
      confirmButtonText: $t('expire_dialog.2'),
      showCancelButton: true,
      cancelButtonText: $t('66')
    }).then(function (_) {
      return window.open('https://www.flash-hr.com/contact-us');
    }).catch(function (_) {
      return false;
    }).finally(function (_) {
      return Cookies.set('isExpireDialog', true, {
        expires: process.env.NODE_ENV === 'production' ? 7 : new Date(Date.now() + 30 * 1000)
      });
    });
  }
});